import { Grid as AntdGrid } from 'antd'
import { useBreakpoint } from './hooks/useBreakpoint'

export const Grid = Object.assign(AntdGrid, {
  useBreakpoint
})
